export default __webpack_public_path__ + "971f8f2dba133b8a589a6b0a14dddb60.png";